module.exports = __webpack_public_path__ + "img/VIETINBANK.1dc360d2.svg";